import { render, staticRenderFns } from "./m_answershortquestion.vue?vue&type=template&id=186d3d3c&scoped=true&"
import script from "./m_answershortquestion.vue?vue&type=script&lang=js&"
export * from "./m_answershortquestion.vue?vue&type=script&lang=js&"
import style0 from "./m_answershortquestion.vue?vue&type=style&index=0&id=186d3d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d3d3c",
  null
  
)

export default component.exports